import React , { useState } from "react";
import { LoginImg1, LoginImg2, LoginImg3, logo } from "../../imagepath";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import { useParams ,useLocation } from "react-router-dom";
import AuthServices from "../../../services/AuthServices";
import { useNavigate } from "react-router-dom";
import {showErrorAlerts,showsuccessAlert} from '../../../services/AlertService';

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { token } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  
  const [form, setForm] = useState({ newPassword: confirmPassword, type: type});
    var settings = {
        //autoWidth: true,
        items: 2,
        margin: 25,
        dots: true,
        nav: true,
        navText: [
          '<i className="fas fa-arrow-left"></i>',
          '<i className="fas fa-arrow-right"></i>',
        ],
    
        loop: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 1,
          },
          1170: {
            items: 1,
          },
        },
      };
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
          showErrorAlerts("Passwords do not match!");
            return;
          }
          const updatedForm = {
            newPassword: password, // Assign the correct password value
            type: type,
        };
        try {
          console.log(token,"token--")
          const response = await AuthServices.resetPassword(token,updatedForm);
console.log(response,'get response');
if(response && response.message){
  showsuccessAlert(response.message);
  navigate('/login');
}
       
        } catch (err) {console.log(err.response.data.error);
          // alert(err.response.data.error);
        }
    };
  return (
    <>
      <div className="main-wrapper">
        <div className="row">
          {/* Login Banner */}
          <div className="col-md-6 login-bg">
          <OwlCarousel 
            {...settings}
            className="owl-carousel login-slide owl-theme">
              <div className="welcome-login">
                <div className="login-banner">
                  <img
                    src={LoginImg1}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h2>
                    Welcome to <br />
                    AngelWatchLMS Courses.
                  </h2>
                  <p>
                    Our commitment is to make the center run smoother in case of any emergency big or small. We do not overwhelm a staff,
                    meaning, we do not overload them with paperwork and lengthy training manuals because that will not work. We understand the
                    capacity of the staff and make it easy for them to understand and do. Practical application of our trainings always works the best.
                    It will let the center owners know who or what is the weakest link in their centers and in our line of training and specialty, the life
                    they save may be their own.
                  </p>
                </div>
              </div>
              <div className="welcome-login">
                <div className="login-banner">
                  <img
                    src={LoginImg2}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h2>
                    Welcome to <br />
                    AngelWatchLMS Courses.
                  </h2>
                  <p>
                    All of our techniques, trainings, equipment, software, hardware and instructions are considered classified material and owned by
                    the AngelWatch Foundation. We do not share our information on how we teach. The reason, we keep the center, staff and
                    children protected at all times. We never want anyone to try to figure out a way to bypass our trainings. We always improve,
                    change and adapt to make sure that we have every base covered.
                  </p>
                </div>
              </div>
              <div className="welcome-login">
                <div className="login-banner">
                  <img
                    src={LoginImg3}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h2>
                    Welcome to <br />
                    AngelWatchLMS Courses.
                  </h2>
                  <p>
                    The AngelWatch Foundation is partnered with the American Red Cross and backed by the
                    Department of Homeland Security and we are the only national accreditation for the Safety and
                    Security for centers and children in the Country.
                  </p>
                </div>
              </div>
            </OwlCarousel>
          </div>
          {/* /Login Banner */}
          <div className="col-md-6 login-wrap-bg">
            {/* Login */}
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="img-logo">
                  <img
                    src={logo}
                    className="img-fluid"
                    alt="Logo"
                  />
                  <div className="back-home">
                    <Link to="/home">Back to Home</Link>
                  </div>
                </div>
                <h1>Reset Password </h1>
                <div className="reset-password">
                  <p>Enter New Password to reset your password.</p>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                  <label className="form-control-label">New Password</label>
                    <div className="pass-group" id="passwordInput">
                    <input
                        type="password"
                        className="form-control"
                        placeholder="New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        />
                      </div>
                  </div>
                  <div className="input-block">
                  <label className="form-control-label">Confirm Password</label>
                    <div className="pass-group" id="passwordInput">
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        />
                      </div>
                  </div>
                  <div className="d-grid">
                    <button className="btn btn-start" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/* /Login */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
